import { render, staticRenderFns } from "./zyspDetail.vue?vue&type=template&id=416e9baf&scoped=true&"
import script from "./zyspDetail.vue?vue&type=script&lang=js&"
export * from "./zyspDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./zyspDetail.vue?vue&type=style&index=1&id=416e9baf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e9baf",
  null
  
)

export default component.exports